export default __webpack_public_path__ + "fonts/login-background.svg";